export default __webpack_public_path__ + "static/media/mobile_banner_liability.f4423b01.jpg";